var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"catalog"},[_c('category-list',{model:{value:(_vm.filters),callback:function ($$v) {_vm.filters=$$v},expression:"filters"}}),_c('course-list',{attrs:{"filters":_vm.filters,"pagination":true,"courses":_vm.allCourses}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }